import { makeStyles } from "@material-ui/core";

export const dashboardStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#0a1520'
    },

    dashboardSelector: {
        marginBottom: theme.spacing(3)
    },

    filtersCard: {
        marginBottom: theme.spacing(3),
        backgroundColor: '#0f1c2e',
        border: '0.5px solid rgba(90,180,232,0.25)'
    },

    metricCard: {
        height: "100%",
        backgroundColor: '#0f1c2e',
        border: '0.5px solid rgba(90,180,232,0.25)'
    },

    metricValue: {
        fontSize: 32,
        fontWeight: 700,
    },

    metricLabel: {
        color: theme.palette.text.secondary,
    },

    metricVariation: {
        marginTop: theme.spacing(1),
        fontSize: 12,
        color: "#2e7d32",
    },

    sectionTitle: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },

}));
